import discovery from "./article-discovery.generated.json";
import type { Locale } from "./i18n/config";

/** Safe for client navigation: language pairs and dates, never complete article bodies. */
export const authoredPairs = discovery.pairs as (Partial<Record<Locale, string>> & { es: string })[];
export const authoredSummaries = discovery.revisions as { locale: Locale; slug: string; modified: string; sourcesChecked: string; revision: string }[];
